/*
 * Single source of truth for Module Federation remote-entry URLs.
 *
 * Consumed in two places that must never drift apart:
 *   - build time:  vite.config.js, with loadEnv()'s `env` object
 *   - runtime:     src/utilities/mfe/remoteUrls.js, with import.meta.env
 *
 * Kept as a pure factory (env passed in) so it must NOT reference import.meta.env
 * at module scope — vite.config.js imports this in a plain Node context where
 * import.meta.env does not exist.
 */

const buildRemoteUrls = (env) => ({
  capital: `${env.VITE_CAPITAL_REMOTE_URI}/assets/capital-remote-entry.js`,
  inventory: `${env.VITE_INVENTORY_REMOTE_URI}/assets/inventory-remote-entry.js`,
  transportation: `${env.VITE_TRANSPORTATION_REMOTE_URI}/assets/transportation-hub-remote-entry.js`,
  panda: `${env.VITE_PANDA_REMOTE_URI}/assets/panda-remote-entry.js`,
  sellerControlRoom: `${env.VITE_SELLER_CONTROL_ROOM_REMOTE_URI}/assets/seller-control-room-remote-entry.js`,
  offersPortal: `${env.VITE_OFFERS_PORTAL_REMOTE_URI}/assets/acv-offers-portal-remote-entry.js`,
});

export default buildRemoteUrls;
